export default __webpack_public_path__ + "static/media/deliveryTime.0898e430.svg";